import React from 'react';

import type { Repub } from '@cx-modules/constants';

import type INavData from '../../interfaces/config/nav';

import Header from './header';

interface IProps {
	isRebrandEnabled: boolean;
	navData: INavData;
	repub: Repub;
	resourcesUrl: string;
}

const HeaderContainer: React.FC<IProps> = ({
	isRebrandEnabled,
	navData,
	repub,
	resourcesUrl,
}) => {
	if (!navData) {
		console.warn('navData is not provided');
		return null;
	}

	const { eventMenu } = navData;

	let subMenu: Array<any> = [];

	if (eventMenu) {
		const text = eventMenu.text || '';

		const type = eventMenu.menuType; // used to set the type of navigation to use
		if (eventMenu?.select?.menu) {
			subMenu = eventMenu.select.menu.slice(0);
		}

		let homepageData: unknown = null;
		if (type === 'default' && eventMenu.url) {
			homepageData = {
				text,
				url: eventMenu.url,
			};
			subMenu.unshift(homepageData);
		}
	}
	return (
		<Header
			navData={navData}
			subMenu={subMenu}
			repub={repub}
			resourcesUrl={resourcesUrl}
			isRebrandEnabled={isRebrandEnabled}
		/>
	);
};

export default HeaderContainer;
